module.exports = __webpack_public_path__ + "block.svg?e19bc0cddd87daaa535f29faa211ec2e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/block.svg
// module id = 244
// module chunks = 0